/*
 *
 * MsTeamsVerify constants
 *
 */

import { defineApiActionTypes } from 'utils/action-helper';
const prefix = 'ui/containers/MsTeamsVerify';

/*
 * @dev defineApiActionTypes a function that
 * return concat base with START,SUCCESS,FAILURE
 */
export const VERIFY_MSTEAMS = defineApiActionTypes(`${prefix}/VERIFY_MSTEAMS_START`);
